// Cari listesi > Tablo Sütunlarını Özelleştir penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'accounts.tableSettings';

export const accountsTableSettingsGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Sütun ayarları nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Bu pencereden cari listesinde hangi sütunların görüneceğini ve hangilerine göre sıralama yapılabileceğini seçersiniz. İyi ayarlanmış bir tablo arama, takip ve raporlamayı hızlandırır.'),
  regionLabels: {
    body: t(`${G}.regions.body`, 'Sütun listesi'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Sabit sütunlar gizlenemez'),
      text: t(`${G}.s1.text`, 'Sabit sütunlar her zaman görünür; satırın kimliği, temel bakiye ve satır işlemleri bu sütunlarla çalışır. Bunlarda yalnız sıralamayı açıp kapatabilirsiniz (sıralamayı destekleyen sütunlarda).'),
      tips: [
        t(`${G}.s1.tip1`, 'Sıra no ve İşlemler sütunlarında sıralama yoktur.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Diğer sütunları ihtiyaca göre açın'),
      text: t(`${G}.s2.text`, 'Özelleştirilebilir sütunlarda "Görünür" anahtarıyla sütunu açıp kapatın. Örneğin tahsilat odaklı çalışmada iletişim alanlarını, muhasebe kontrolünde vergi ve finans alanlarını görünür tutun.'),
      tips: [
        t(`${G}.s2.tip1`, 'Bir sütunun ne gösterdiğini görmek için yanındaki bilgi simgesinin üzerine gelin.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Sıralamayı ayarlayın'),
      text: t(`${G}.s3.text`, '"Sırala" anahtarı, listede o sütuna göre sıralama yapılmasını sağlar. Bir sütunu gizlerseniz sıralaması da kendiliğinden kapanır; böylece liste görünmeyen bir alana göre sıralanmaz.'),
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Önerilen düzen'),
      text: t(`${G}.s4.text`, 'Herkesin aynı düzeni kullanması, listeyi aynı şekilde okumayı ve iş devrini kolaylaştırır.'),
      tips: [
        t(`${G}.s4.tip1`, 'Önce ekibinizin her gün en çok kullandığı 5-7 sütunu görünür bırakın.'),
        t(`${G}.s4.tip2`, 'Sonra karar vermek için gereken 1-2 önemli sütunda sıralamayı açın.'),
        t(`${G}.s4.tip3`, 'Kaydetmeden önce listeye kısaca göz atın.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Kaydedin'),
      text: t(`${G}.s5.text`, '"Değişiklikleri Kaydet" ayarları uygular, "İptal" bırakır. Ayarlar bu cihazda saklanır ve tekrar açtığınızda korunur; başka bir cihazda aynı görünüm için ayarı orada da bir kez yapmanız gerekir.'),
    },
  ],
});
